import { Button, WellBox } from '@components/';
import { FaRegCheckCircle } from 'react-icons/fa';
import { useSuccess } from './useSuccess';

export function Success() {
  const { navigate, ticket } = useSuccess();

  return (
    <div className="h-[96vh] flex flex-col bg-[#EDF8F4]">
      <div className="flex flex-col justify-center items-center gap-4 h-[70vh] p-4">
        <FaRegCheckCircle className="text-green-800 w-13 h-13" />
        <h1 className="text-green-800 font-bold text-2xl text-center">
          Solicitação criada com sucesso!
        </h1>

        <WellBox
          content={
            <div className="flex flex-col gap-2">
              <p className="text-sm text-[#1D1D30]">
                Sucesso, você acaba de criar um ticket!
              </p>
              <ul>
                <li className="list-disc list-inside text-sm text-[#1D1D30]">#{ticket}</li>
              </ul>
            </div>
          }
        />
      </div>

      <div className="w-full bg-white border-t border-[#D8DCDE] mt-auto p-4 bottom-0">
        <Button className="w-full rounded-[8px]" onClick={() => navigate('/')}>
          Voltar
        </Button>
      </div>
    </div>
  );
}
